export default "__VITE_ASSET__BCoHwiqM__"